import { render, staticRenderFns } from "./EntityDetail.vue?vue&type=template&id=3f719564&scoped=true&"
import script from "./EntityDetail.vue?vue&type=script&lang=js&"
export * from "./EntityDetail.vue?vue&type=script&lang=js&"
import style0 from "./EntityDetail.vue?vue&type=style&index=0&id=3f719564&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f719564",
  null
  
)

export default component.exports